import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PortalModule } from 'src/app/core/portal/portal.module';
import { SharedCommonDirectivesModule } from '../directives/shared-common-directives.module';
import { MaterialCommonModule } from '../material/material-common.module';
import { MaterialModule } from '../material/material.module';
import { SharedPipeModule } from '../pipes/shared-pipe.module';
import { AuthorizedGuardComponent } from './authorized-guard/authorized-guard.component';
import { BatteryStatusComponent } from './battery-status/battery-status.component';
import { ChipComponent } from './chip/chip.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { HeartbeatStatusComponent } from './heartbeat-status/heartbeat-status.component';
import { IndicatorComponent } from './indicator/indicator.component';
import { RelevanceIndicatorDirective } from './indicator/relevance-indicator.directive';
import { LoadingGuardComponent } from './loading-guard/loading-guard.component';
import { LocationLinkComponent } from './location-link/location-link.component';
import { PasswordStrengthIndicatorComponent } from './password-strength-indicator/password-strength-indicator.component';
import { PasswordToggleComponent } from './password-toggle/password-toggle.component';
import { PrivilegedLinkComponent } from './privileged-link/privileged-link.component';
import { ReactIframeComponent } from './react-iframe/react-iframe.component';
import { RelevanceStatusChipComponent } from './relevance-status-chip/relevance-status-chip.component';
import { SidebarToolbarComponent } from './sidebar-toolbar/sidebar-toolbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MaterialCommonModule,
    PortalModule,
    RouterModule,
    SharedCommonDirectivesModule,
    SharedPipeModule,
  ],
  declarations: [
    AuthorizedGuardComponent,
    BatteryStatusComponent,
    LoadingGuardComponent,
    HeartbeatStatusComponent,
    PrivilegedLinkComponent,
    IndicatorComponent,
    RelevanceIndicatorDirective,
    ChipComponent,
    SidebarComponent,
    ReactIframeComponent,
    RelevanceStatusChipComponent,
    LocationLinkComponent,
    ConfirmationDialogComponent,
    SidebarToolbarComponent,
    PasswordToggleComponent,
    PasswordStrengthIndicatorComponent,
  ],
  exports: [
    AuthorizedGuardComponent,
    BatteryStatusComponent,
    LoadingGuardComponent,
    HeartbeatStatusComponent,
    PrivilegedLinkComponent,
    IndicatorComponent,
    RelevanceIndicatorDirective,
    ChipComponent,
    SidebarComponent,
    ReactIframeComponent,
    RelevanceStatusChipComponent,
    LocationLinkComponent,
    ConfirmationDialogComponent,
    SidebarToolbarComponent,
    PasswordToggleComponent,
    PasswordStrengthIndicatorComponent,
  ],
})
export class SharedComponentModule {}
